import Routes from "~/constants/routes";
import CommonTile from "./CommonTile";
import Table from "~/pages/Journals/UserActivityLog/Table";
import { useTranslation } from "react-i18next";
import { PERMISSION } from "~/api/permissions/enums";
import usePermissions from "~/hook/usePermissions";
import api from "~/api";

const UserActivityLogWidget = () => {
  const { t } = useTranslation();
  const { hasAll } = usePermissions();

  if (!hasAll(PERMISSION.READ_JOURNAL_OF_USERS_ACTIONS)) return null;

  const getData = () =>
    api.userActivityJournal
      .getUsersActivities(5, 1, { sort: "-createdAt" })
      .then((res) => res.data.data);

  return (
    <CommonTile
      title={t("title.userActivityLog")}
      showAllText={t("button.showAll")}
      onUpdate={getData}
      showAllLink={Routes.USER_ACTIVITY}
    >
      {(data) => <Table dataSource={data || []} hideSorting={true} />}
    </CommonTile>
  );
};

export default UserActivityLogWidget;
